"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Icons_1 = require("../../../Icons");
var SearchableNestedDropdown_context_1 = require("../SearchableNestedDropdown.context");
var Header_styles_1 = require("./Header.styles");
exports.default = (function () {
    var _a = React.useContext(SearchableNestedDropdown_context_1.SndContext), Placeholder = _a.Placeholder, OpenDropdown = _a.OpenDropdown;
    var handleOnClick = function (e) {
        e.nativeEvent.stopImmediatePropagation();
        OpenDropdown();
    };
    return (React.createElement(Header_styles_1.ClosedHeader, { onClick: handleOnClick, role: "button" },
        React.createElement(Header_styles_1.PlaceholderText, null, Placeholder),
        React.createElement(Header_styles_1.HeaderIcon, null,
            React.createElement(Icons_1.SearchIcon, null))));
});
